<template>
  <v-container fluid class="no-padding">
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      v-on:close="showDismissibleAlert = false"
    />
    <div v-if="startScanning && !disableForm">
      <v-dialog
        v-model="startScanning"
        fullscreen
        transition="dialog-bottom-transition"
      >
        <v-card
          flat
          outlined
          :dark="$store.getters.getColorPalette().isDark"
          :color="$store.getters.getColorPalette().background2ColorCode"
        >
          <QRCodeScanner
            :fieldData="fieldData"
            v-on:qrData="addQRData"
            v-on:goBack="toggleScan"
          />
        </v-card>
      </v-dialog>
    </div>
    <div v-if="startImageUpload && !disableForm">
      <v-dialog
        v-model="startImageUpload"
        fullscreen
        transition="dialog-bottom-transition"
      >
        <v-card
          flat
          outlined
          :dark="$store.getters.getColorPalette().isDark"
          :color="$store.getters.getColorPalette().background2ColorCode"
        >
          <OCRComponent
            :fieldData="fieldData"
            v-on:ocrData="addOCRData"
            v-on:goBack="toggleImageComponent"
          />
        </v-card>
      </v-dialog>
    </div>
    <!-- Static -->
    <div v-if="cell.type === 'static'">
      <span>{{ cell.value }}</span>
    </div>
    <!-- Input -->
    <div v-else-if="cell.type === 'input'">
      <!-- Checkbox -->
      <span v-if="cell.value.type === 'check'">
        <v-checkbox
          :disabled="
            (logbookData &&
              logbookData.logbook_id &&
              logbookData.stage !== 'maker') ||
            readOnly ||
            (cell && cell.value && cell.value.meta && cell.value.meta.unlockAt
              ? isCellLocked(cell.value.meta.unlockAt)
              : false)
          "
          v-model="
            templateMeta[main_index].data_meta.rows[row_index][cell_index].value
              .data
          "
          hide-details
          :color="$store.getters.getColorPalette().accentCode"
        ></v-checkbox>
      </span>
      <!-- Text -->
      <span v-if="cell.value.type === 'text'">
        <span v-if="readOnly">{{
          templateMeta[main_index].data_meta.rows[row_index][cell_index].value
            .data
            ? templateMeta[main_index].data_meta.rows[row_index][cell_index]
                .value.data
            : "No data filled"
        }}</span>
        <v-text-field
          v-else
          :disabled="
            (logbookData &&
              logbookData.logbook_id &&
              logbookData.stage !== 'maker') ||
            readOnly ||
            (cell && cell.value && cell.value.meta && cell.value.meta.unlockAt
              ? isCellLocked(cell.value.meta.unlockAt)
              : false)
          "
          v-model="
            templateMeta[main_index].data_meta.rows[row_index][cell_index].value
              .data
          "
          dense
          placeholder="Type your Input"
          hide-details
          class="pa-0"
        >
        </v-text-field>
      </span>
      <!-- Dependent List Text -->
      <span v-if="cell.value.type === 'dependent_list_text' && !loading">
        <!-- <v-select -->
        <span v-if="readOnly">{{
          templateMeta[main_index].data_meta.rows[row_index][cell_index].value
            .data
            ? templateMeta[main_index].data_meta.rows[row_index][cell_index]
                .value.data
            : "No data filled"
        }}</span>
        <v-autocomplete
          v-else
          class="full-width-autocomplete pa-0"
          :disabled="
            (logbookData &&
              logbookData.logbook_id &&
              logbookData.stage !== 'maker') ||
            readOnly ||
            (cell && cell.value && cell.value.meta && cell.value.meta.unlockAt
              ? isCellLocked(cell.value.meta.unlockAt)
              : false)
          "
          v-model="
            templateMeta[main_index].data_meta.rows[row_index][cell_index].value
              .data
          "
          :items="
            getDependentListByQueryKey(
              cell.value.meta.list_id,
              templateMeta[main_index].data_meta.rows[row_index][
                cell.value.meta.column_no - 1
              ].value.data
            )
          "
          item-text="tag"
          item-value="value"
          placeholder="Select your Input"
          dense
          outlined
          hide-details
        >
        </v-autocomplete>
        <!-- </v-select> -->
      </span>
      <!-- List Text -->
      <span v-if="cell.value.type === 'list_text' && !loading">
        <!-- <v-select -->
        <span v-if="readOnly">{{
          templateMeta[main_index].data_meta.rows[row_index][cell_index].value
            .data
            ? templateMeta[main_index].data_meta.rows[row_index][cell_index]
                .value.data
            : "No data filled"
        }}</span>
        <v-autocomplete
          v-else
          :disabled="
            (logbookData &&
              logbookData.logbook_id &&
              logbookData.stage !== 'maker') ||
            readOnly ||
            (cell && cell.value && cell.value.meta && cell.value.meta.unlockAt
              ? isCellLocked(cell.value.meta.unlockAt)
              : false)
          "
          v-model="
            templateMeta[main_index].data_meta.rows[row_index][cell_index].value
              .data
          "
          :items="listDropdown(cell.value.meta.list_id)"
          item-text="label"
          item-value="value"
          placeholder="Select your Input"
          dense
          outlined
          hide-details
          block
          class="pa-0 w-"
        >
        </v-autocomplete>

        <!-- </v-select> -->
      </span>
      <div v-if="cell.value.type === 'clock' && !loading">
        <div :style="{ padding: '10px 10px' }">
          {{
            templateMeta[main_index].data_meta.rows[row_index][cell_index].value
              .data
              ? templateMeta[main_index].data_meta.rows[row_index][
                  cell_index
                ].value.data.toString() + " Hr"
              : "--:--"
          }}
        </div>
        <div
          v-if="
            logbookData &&
            logbookData.logbook_id &&
            logbookData.stage === 'maker' &&
            !readOnly
            // &&
            // !(cell && cell.value && cell.value.meta && cell.value.meta.unlockAt
            //   ? isCellLocked(cell.value.meta.unlockAt)
            //   : false)
          "
        >
          <TimePicker
            v-model="
              templateMeta[main_index].data_meta.rows[row_index][cell_index]
                .value.data
            "
          />
        </div>
      </div>

      <div
        :style="{ margin: '10px' }"
        v-if="cell.value.type === 'calendar' && !loading"
      >
        <div
          :style="{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '10px',
            padding: '10px',
          }"
        >
          <div>
            {{
              getFormattedDate(
                templateMeta[main_index].data_meta.rows[row_index][cell_index]
                  .value.data
              )
            }}
          </div>
          <div
            v-if="
              logbookData &&
              logbookData.logbook_id &&
              logbookData.stage === 'maker' &&
              !readOnly &&
              (cell && cell.value && cell.value.meta && cell.value.meta.unlockAt
                ? !isCellLocked(cell.value.meta.unlockAt)
                : true)
            "
          >
            <v-menu
              v-model="menuState[`${main_index}-${row_index}-${cell_index}`]"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              :dark="$store.getters.getColorPalette().isDark"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  :dark="$store.getters.getColorPalette().isDark"
                >
                  <v-icon>mdi-calendar</v-icon>
                </v-btn>
              </template>
              <v-date-picker
                v-model="
                  templateMeta[main_index].data_meta.rows[row_index][cell_index]
                    .value.data
                "
                color="cyan lighten-1"
                @change="
                  menuState[`${main_index}-${row_index}-${cell_index}`] = false
                "
                :dark="$store.getters.getColorPalette().isDark"
              ></v-date-picker>
            </v-menu>
          </div>
        </div>
      </div>

      <!-- QR Code -->
      <div v-if="cell.value.type === 'qrtext' && !loading">
        <span class="pa-5">
          {{
            templateMeta[main_index].data_meta.rows[row_index][cell_index].value
              .data
          }}
        </span>
        <span
          v-if="
            !startScanning &&
            logbookData &&
            logbookData.logbook_id &&
            logbookData.stage === 'maker' &&
            !readOnly &&
            cell &&
            cell.value &&
            cell.value.meta &&
            cell.value.meta.unlockAt
              ? !isCellLocked(cell.value.meta.unlockAt)
              : true
          "
          class="ma-2"
        >
          <v-btn
            :color="$store.getters.getColorPalette().downloadbtnColor"
            outlined
            small
            @click="
              toggleScan({
                main_index,
                row_index,
                cell_index,
              })
            "
            >Scan QR</v-btn
          >
        </span>
      </div>
      <!-- OCR -->
      <div v-if="cell.value.type === 'ocr' && !loading">
        <span class="pa-5">
          {{
            templateMeta[main_index].data_meta.rows[row_index][cell_index].value
              .data
          }}
        </span>
        <span
          v-if="
            !startScanning &&
            logbookData &&
            logbookData.logbook_id &&
            logbookData.stage === 'maker' &&
            !readOnly &&
            (cell && cell.value && cell.value.meta && cell.value.meta.unlockAt
              ? !isCellLocked(cell.value.meta.unlockAt)
              : true)
          "
          class="ma-2"
        >
          <v-btn
            :color="$store.getters.getColorPalette().downloadbtnColor"
            outlined
            small
            @click="
              toggleImageComponent({
                main_index,
                row_index,
                cell_index,
              })
            "
            >Scan Image</v-btn
          >
        </span>
      </div>
    </div>
    <!-- Auto -->
    <div v-else>
      <div
        v-if="
          cell.value.data &&
          !(
            cell.value.type === 'current_time' ||
            cell.value.type === 'param' ||
            cell.value.type === 'dependent_param'
          )
        "
      >
        <div>{{ cell.value.data }}</div>
        <div>(Auto Generated)</div>
      </div>
      <div class="mb-1" v-else-if="cell.value.type === 'current_time'">
        <div class="my-1">
          {{
            cell.value.data
              ? cell.value.data
              : addCurrentTime(
                  main_index,
                  row_index,
                  cell_index,
                  templateMeta[main_index].data_meta.rows[row_index][cell_index]
                    .value.template
                )
          }}
        </div>
        <v-btn
          v-if="logbookData.stage !== 'approver'"
          color="accent"
          small
          @click="
            addCurrentTime(
              main_index,
              row_index,
              cell_index,
              templateMeta[main_index].data_meta.rows[row_index][cell_index]
                .value.template
            )
          "
        >
          <v-icon small>mdi-clock-plus-outline</v-icon>
        </v-btn>
      </div>
      <div v-else-if="cell.value.type === 'param' && !loading">
        <div class="my-1">
          {{
            cell.value.data ? cell.value.data : cell.value.template.param_label
          }}
        </div>
        <v-btn
          v-if="logbookData.stage !== 'approver'"
          color="accent"
          small
          @click="
            captureParamData(
              main_index,
              row_index,
              cell_index,
              templateMeta[main_index].data_meta.rows[row_index][cell_index]
                .value.template.param_id
            )
          "
        >
          <v-icon small>mdi-card-outline</v-icon>
        </v-btn>
      </div>
      <div v-else-if="cell.value.type === 'dependent_param' && !loading">
        <div class="my-1">
          {{ cell.value.data ? cell.value.data : "" }}
        </div>
        <v-btn
          v-if="logbookData.stage !== 'approver'"
          color="accent"
          small
          @click="captureDependentParamData(main_index, row_index, cell_index)"
        >
          <v-icon small>mdi-card-outline</v-icon>
        </v-btn>
      </div>
      <span
        v-else-if="
          logbookData &&
          logbookData.logbook_id &&
          logbookData.stage === 'maker' &&
          !readOnly
        "
        >This field will be auto filled</span
      >
      <span v-else></span>
    </div>
  </v-container>
</template>
<script>
// import { io } from "socket.io-client";
import moment from "moment";
import FormRules from "@/utillities/FormRules";
import InfoAlert from "@/components/InfoAlert.vue";
import QRCodeScanner from "@/components/reusable_components/QRCodeScanner.vue";
import OCRComponent from "@/components/reusable_components/OCRComponent.vue";
import TimePicker from "@/components/inputs/TimePicker";
export default {
  name: "ManufacturingLogbookMakerForm",
  props: [
    "templateMeta",
    "logbookData",
    "readOnly",
    "main_index",
    "cell_index",
    "row_index",
    "cell",
    "streamData",
    "registerParam",
  ],
  components: {
    InfoAlert,
    QRCodeScanner,
    OCRComponent,
    TimePicker,
  },
  data() {
    return {
      info: "",
      showDismissibleAlert: false,
      loading: false,
      menuState: {},
      menu2: false,
      menu1: false,
      fieldData: null,
      startScanning: false,
      startImageUpload: false,
      paramList: [],
      copiedData: [],
      rules: FormRules.rules,
      stream: null,
      // streamData: {},
      // singleStreamData: {},
      dateTimeFormatMap: {
        "YYYY-MM-DD": "YYYY-MM-DD",
        "YYYY-MM-DD HH:mm": "YYYY-MM-DD HH:mm",
        "DD-MM-YYYY HH:mm": "DD-MM-YYYY HH:mm",
        "DD-MM-YYYY": "DD-MM-YYYY",
        "MM-YYYY": "MM-YYYY",
        "DD-MM": "DD-MM",
        "HH:MM": "HH:mm",
        "HH:mm": "HH:mm",
      },
      ISODateRules: [
        (v) => !!v || this.$store.getters.getTextMap().required,
        (v) =>
          /[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9]$/.test(v) ||
          "It should be a Date",
      ],
    };
  },
  // created() {
  //   this.stream = io(this.$store.state.streamApi, {
  //     withCredentials: true,
  //     auth: { token: this.$store.state.jwt },
  //   });
  // },
  // beforeDestroy() {
  //   this.stream.close();
  // },
  // mounted() {
  //   this.init();
  //   // console.log(this.cell,this.readOnly)
  // },
  methods: {
    getShiftData(shift_id, from_time) {
      let shiftData = this.$store.getters.getShiftDataById(shift_id);
      let temp = shiftData.filter((x) => x.from_time === from_time);
      let to_time = temp[0].to_time;
      return to_time;
    },
    isCurrentTimeInRange(from_time, to_time) {
      const now = new Date();
      const currentMinutes = now.getHours() * 60 + now.getMinutes();
      // Convert from_time and to_time to minutes
      const [fromHours, fromMinutes] = from_time.split(":").map(Number);
      const [toHours, toMinutes] = to_time.split(":").map(Number);
      const fromTotal = fromHours * 60 + fromMinutes;
      const toTotal = toHours * 60 + toMinutes;
      return currentMinutes >= fromTotal && currentMinutes <= toTotal;
    },
    isCellLocked(unlockAt) {
      let disableCell = true;
      if (unlockAt && unlockAt.shiftTime) {
        for (let i of unlockAt["shiftTime"]) {
          if (
            this.isCurrentTimeInRange(
              i.from_time,
              this.getShiftData(i.shift_id, i.from_time)
            )
          ) {
            disableCell = false;
            break;
          }
        }
      } else {
        disableCell = false;
      }
      return disableCell;
    },
    // subscribe() {
    //   if (this.paramList && this.paramList.length > 0) {
    //     this.paramList.forEach((param) => {
    //       if (param.type == "rtd") {
    //         // this.stream.emit("getParam", param.param_id);
    //         this.registerParam({ param_id: param.param_id, param_type: "rtd" });
    //       } else if (param.type == "rtc") {
    //         // this.stream.emit("getParamConsumption", param.param_id);
    //         this.registerParam({ param_id: param.param_id, param_type: "rtc" });
    //       }
    //     });
    //   }
    // },
    subscribeForSingleParam(param_id, param_type = "rtd") {
      if (param_type == "rtd") {
        // this.stream.emit("getParam", param_id);
        this.registerParam({ param_id, param_type });
      } else if (param_type == "rtc") {
        this.stream.emit("getParamConsumption", param_id);
        this.registerParam({ param_id, param_type });
      }
    },
    // streamInit() {
    //   this.stream.on("connect_error", (err) => {
    //     console.error(err.message);
    //   });
    //   this.stream.on("error", (data) => {
    //     console.error(data);
    //   });
    //   this.stream.on("param", (data) => {
    //     if (data.constructor == String) {
    //       data = JSON.parse(data);
    //     }
    //     let temp = Object.assign({}, this.streamData);
    //     temp[data.param_id] = Math.round(Number(data.data) * 1000) / 1000;
    //     this.streamData = temp;
    //   });

    //   this.stream.on("paramConsumption", (data) => {
    //     if (data.constructor == String) {
    //       data = JSON.parse(data);
    //     }
    //     let temp = Object.assign({}, this.streamData);
    //     temp[data.param_id] = Math.round(Number(data.data) * 1000) / 1000;
    //     this.streamData = temp;
    //   });
    //   this.subscribe();
    // },
    // streamInitForSingleParam() {
    //   this.stream.on("connect_error", (err) => {
    //     console.error(err.message);
    //   });
    //   this.stream.on("error", (data) => {
    //     console.error(data);
    //   });
    //   this.stream.on("param", (data) => {
    //     if (data.constructor == String) {
    //       data = JSON.parse(data);
    //     }
    //     let temp = Object.assign({}, this.singleStreamData);
    //     temp[data.param_id] = Math.round(Number(data.data) * 1000) / 1000;
    //     this.singleStreamData = temp;
    //   });

    //   this.stream.on("paramConsumption", (data) => {
    //     if (data.constructor == String) {
    //       data = JSON.parse(data);
    //     }
    //     let temp = Object.assign({}, this.singleStreamData);
    //     temp[data.param_id] = Math.round(Number(data.data) * 1000) / 1000;
    //     this.singleStreamData = temp;
    //   });
    // },
    captureParamData(main_index, row_index, cell_index, param_id) {
      this.loading = true;
      let streamData = this.streamData;
      let value = streamData[param_id];
      if (value) {
        this.templateMeta[main_index].data_meta.rows[row_index][
          cell_index
        ].value.data = value;
      } else {
        if (param_id) {
          let param_type =
            this.templateMeta[main_index].data_meta.rows[row_index][cell_index]
              .value.template.param_type;
          this.subscribeForSingleParam(param_id, param_type);
          setTimeout(() => {
            this.getParamStreamData(
              main_index,
              row_index,
              cell_index,
              param_id
            );
          }, 2000);
        }
      }

      this.loading = false;
    },
    captureDependentParamData(main_index, row_index, cell_index) {
      this.loading = true;
      let streamData = this.streamData;
      // let streamData = this.singleStreamData;

      let query_text =
        this.templateMeta[main_index].data_meta.rows[row_index][cell_index]
          .value.template.col;
      let matches = query_text.match(/C\d+/g);
      if (matches) {
        matches.forEach((colRef) => {
          const colIndex = parseInt(colRef.substring(1), 10) - 1;
          const cellValue =
            this.templateMeta[main_index].data_meta.rows[row_index][colIndex]
              ?.value.data ?? "";
          const colRefRegex = new RegExp(colRef, "g");
          query_text = query_text.replace(colRefRegex, cellValue);
        });
      }

      let query_id =
        this.templateMeta[main_index].data_meta.rows[row_index][cell_index]
          .value.template.query_id;
      let param_type = this.templateMeta[main_index].data_meta.rows[row_index][
        cell_index
      ].value.template.param_type
        ? this.templateMeta[main_index].data_meta.rows[row_index][cell_index]
            .value.template.param_type
        : "rtd";
      let paramDetails = this.$store.getters.getQueryParamMapDataByIdAndKey(
        query_id,
        query_text
      );
      let param_id = null;
      if (paramDetails && paramDetails.length > 0) {
        param_id = paramDetails[0].param_id;
      }
      let value = streamData[param_id];
      if (value) {
        this.loading = true;
        this.templateMeta[main_index].data_meta.rows[row_index][
          cell_index
        ].value.data = value;
        this.loading = false;
      } else {
        if (param_id) {
          this.subscribeForSingleParam(param_id, param_type);
          setTimeout(() => {
            this.getSingleParamStreamData(
              param_id,
              main_index,
              row_index,
              cell_index
            );
          }, 2000);
        }
      }

      this.loading = false;
    },
    getSingleParamStreamData(param_id, main_index, row_index, cell_index) {
      this.loading = true;
      let streamData = this.streamData;
      // let streamData = this.singleStreamData;
      if (streamData) {
        let value = streamData[param_id];
        this.templateMeta[main_index].data_meta.rows[row_index][
          cell_index
        ].value.data = value;
      }
      this.loading = false;
    },
    getParamStreamData(main_index, row_index, cell_index, param_id) {
      this.loading = true;
      let streamData = this.streamData;
      // let streamData = this.singleStreamData;
      if (streamData) {
        let value = streamData[param_id];
        this.templateMeta[main_index].data_meta.rows[row_index][
          cell_index
        ].value.data = value;
      }
      this.loading = false;
    },
    init() {
      this.copiedData = JSON.parse(JSON.stringify(this.templateMeta));
      // this.streamInitForSingleParam();
      // this.subscribeForSingleParam();
    },
    listDropdown(list_id) {
      let op = [];
      let lists = this.$store.getters.getListDataById(list_id);
      if (lists && lists.length > 0) {
        for (let i of lists) {
          op.push({ label: i.tag, value: i.value });
        }
      }
      return op;
    },
    toggleScan(item) {
      this.fieldData = null;
      if (item) {
        this.fieldData = item;
      }
      this.startScanning = !this.startScanning;
    },
    toggleImageComponent(item) {
      this.fieldData = null;
      if (item) {
        this.fieldData = item;
      }
      this.startImageUpload = !this.startImageUpload;
    },
    addQRData(value) {
      this.loading = true;
      if (value) {
        this.templateMeta[value.main_index].data_meta.rows[value.row_index][
          value.cell_index
        ].value.data = value.qrData;
      }
      this.fieldData = null;
      this.startScanning = false;
      this.loading = false;
    },
    addOCRData(value) {
      this.loading = true;
      if (value) {
        this.templateMeta[value.main_index].data_meta.rows[value.row_index][
          value.cell_index
        ].value.data = value.ocrData;
      }
      this.fieldData = null;
      this.startImageUpload = false;
      this.loading = false;
    },
    getDependentListByQueryKey(list_id, query_key) {
      if (list_id && query_key) {
        return this.$store.getters.getDependentListDataByIdAndKey(
          list_id,
          query_key
        );
      }
      return [];
    },
    getFormattedDate(date, format = "DD-MM-YYYY") {
      if (!date) {
        return moment().format(format);
      }
      return moment(date).format(format);
    },
    createParamList() {
      if (this.copiedData && this.copiedData.length > 0) {
        this.loading = true;
        this.paramList = [];
        let paramSet = [];
        for (let i of this.copiedData) {
          for (let row of i.data_meta.rows) {
            for (let cell of row) {
              if (cell.type === "auto" && cell.value.type === "param") {
                if (
                  !(
                    paramSet &&
                    paramSet.length > 0 &&
                    paramSet.some(
                      (obj) =>
                        obj.param_id === cell.value.template.param_id &&
                        obj.type === cell.value.template.param_type
                    )
                  )
                ) {
                  paramSet.push({
                    param_id: cell.value.template.param_id,
                    type: cell.value.template.param_type,
                  });
                }
              }
            }
          }
        }
        this.paramList = [...paramSet];

        this.loading = false;
      }
    },
    addCurrentTime(main_index, row_index, cell_index, template) {
      this.loading = true;
      let current_time = moment().format(
        template ? this.dateTimeFormatMap[template] : "HH:mm"
      );
      this.templateMeta[main_index].data_meta.rows[row_index][
        cell_index
      ].value.data = current_time;
      this.loading = false;
    },
  },
  watch: {
    logbookData: {
      handler() {
        this.init();
      },
      deep: true,
    },
    copiedData: {
      handler() {
        this.createParamList();
      },
      deep: true,
    },
    // paramList: {
    //   handler() {
    //     this.subscribe();
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style scoped>
.no-padding {
  padding: 0 !important;
  margin: 0 !important;
}
</style>
